import { styled } from "@mui/material/styles";
import { Stepper } from "@mui/material";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import PersonIcon from "@mui/icons-material/Person";
import DoneIcon from "@mui/icons-material/Done";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import {FaBuilding} from "react-icons/fa";
import { v4 as uuidv4 } from 'uuid';

export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 17,
    marginLeft: "6px",
    marginRight: "6px",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#7FB341",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#7FB341",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: "#CACACA",
    borderRadius: 3,
  },
}));

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: "#fff",
  zIndex: 1,
  color: "#A6A6A6",
  padding: "3px",
  display: "flex",
  border: "2px solid #CACACA",
  borderRadius: "50%",
  ...(ownerState.active && {
    backgroundColor: "#7FB341",
    color: "#fff",
    border: "none",
    outline: "2px solid #7FB341",
    outlineOffset: "2px",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#7FB341",
    border: "2px solid #7FB341",
    color: "#fff",
  }),
}));

export function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: completed ? <DoneIcon fontSize="medium" /> : <PersonIcon fontSize="medium" />,
    2: completed ? <DoneIcon fontSize="medium" /> : <FaBuilding fontSize="medium" style={{padding:"4px"}} />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

const StepperForm = () => {
  const stepArray: string[] = ["Step 1", "Step 2", "Step 3"];
  return (
    <Stepper alternativeLabel activeStep={1} connector={<ColorlibConnector />}>
      {stepArray.map((value: string) => {
        return (
          <Step key={uuidv4()}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{value}</StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};
export default StepperForm;
